import { useTranslation } from "react-i18next";

/* Apple App Store badge — local copy so Footer doesn't depend on App.js */
function FooterAppStoreBadge() {
    return (
        <a className="store-badge appstore" href="https://apps.apple.com/app/id6755364999" aria-label="Download on the App Store">
            <span className="icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="24" height="24">
                    <path d="M16.365 12.96c.03 3.273 2.875 4.364 2.905 4.377-.023.074-.455 1.54-1.503 3.05-.905 1.31-1.846 2.62-3.33 2.646-1.46.026-1.926-.85-3.592-.85-1.667 0-2.192.823-3.576.877-1.438.054-2.527-1.414-3.44-2.718-1.87-2.676-3.3-7.56-1.379-10.864.952-1.657 2.653-2.71 4.513-2.737 1.409-.027 2.738.934 3.593.934.856 0 2.476-1.15 4.173-.982.711.03 2.714.278 3.99 2.098-.104.065-2.387 1.393-2.254 3.168zM13.8 3.747c.778-.942 1.303-2.256 1.16-3.557-1.122.046-2.485.746-3.289 1.688-.724.834-1.36 2.172-1.19 3.455 1.26.098 2.54-.64 3.319-1.586z"/>
                </svg>
            </span>
            <span className="txt">
                <em>Download on the</em>
                <strong>App Store</strong>
            </span>
        </a>
    );
}

function FooterGooglePlayBadge() {
    return (
        <a className="store-badge play" href="https://play.google.com/store/apps/details?id=com.marikag.ninoaspace">
            <span className="icon">
                <svg viewBox="0 0 24 24">
                    <path className="c1" d="M3 2l10.5 10.5L3 23z" />
                    <path className="c2" d="M13.5 12.5L17.8 16 6 23z" />
                    <path className="c3" d="M17.8 16l3.2-1.8..." />
                    <path className="c4" d="M13.5 11.5L6 2l11.8 6z" />
                </svg>
            </span>
            <span className="txt">
                <em>GET IT ON</em>
                <strong>Google Play</strong>
            </span>
        </a>
    );
}

export default function Footer({ openAbout }) {
    const { t } = useTranslation();

    return (
        <footer className="footer">
            <div className="footer-inner">

                {/* CTA panel — soft pink card bridging body to footer */}
                <div id="download" className="footer-cta">
                    <div className="footer-cta-content">
                        <img src="/img/Ninoa.svg" alt="Ninoa" className="footer-wordmark" />
                        <p className="footer-cta-text">{t("footer.tagline")}</p>
                    </div>
                    <div className="footer-cta-badges">
                        <FooterAppStoreBadge />
                        <FooterGooglePlayBadge />
                    </div>
                </div>

                <div className="footer-row">

                    {/* Brand column — short blurb + About modal trigger */}
                    <div className="footer-brand-col">
                        <p className="footer-brand-blurb">{t("footer.blurb")}</p>
                        {openAbout && (
                            <button className="footer-about-btn" onClick={openAbout}>
                                {t("header.about")}
                            </button>
                        )}
                    </div>

                    {/* Product column */}
                    <div className="footer-col">
                        <h4>{t("footer.product")}</h4>
                        <a href="/#features">{t("nav.features")}</a>
                        <a href="/#how">{t("nav.how")}</a>
                        <a href="/#pricing">{t("nav.pricing")}</a>
                        <a href="/#conditions">{t("nav.conditions")}</a>
                        <a href="/blog">{t("header.blog")}</a>
                        <a href="/#download">{t("nav.download")}</a>
                    </div>

                    {/* Company column */}
                    <div className="footer-col">
                        <h4>{t("footer.company")}</h4>
                        <a href="/privacy">{t("footer.legal")}</a>
                        <a href="/terms">{t("footer.terms")}</a>
                        <a href="/support">{t("footer.support")}</a>
                        <a href="mailto:support@ninoa.space">{t("footer.contact")}</a>
                    </div>

                </div>

                <div className="footer-bottom">
                    <span className="footer-copyright">&copy; 2026 Ninoa. {t("footer.rights")}</span>
                    <a href="mailto:support@ninoa.space" className="footer-email">
                        support@ninoa.space
                    </a>
                </div>
            </div>
        </footer>
    );
}
